/**
 *
 * PracticePage
 *
 */

import { Component } from "react";
import * as PropTypes from "prop-types";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { createStructuredSelector } from "reselect";
import { compose } from "redux";
import injectSaga from "utils/injectSaga";
import injectReducer from "utils/injectReducer";
import Dashboard from "containers/Dashboard/Dashboard";
import AppContainer from "components/AppContainer/AppContainer";
import styled from "styled-components";
import makeSelectPracticePage, {
  makeSelectPractices,
  makeSelectPractice,
} from "../PracticePage/selectors";
import reducer from "../PracticePage/reducer";
import saga from "../PracticePage/saga";
import messages from "./messages";
import {
  getPracticesAction,
  selectPracticeAction,
} from "../PracticePage/actions";
import { getTreatmentsAction } from "../App/actions";
import { clearTreatmentFromTimeSlotAction } from "../PageState/actions";

export class DashboardPage extends Component {
  static propTypes = {
    getPractices: PropTypes.func.isRequired,
    practices: PropTypes.array.isRequired,
    selectPractice: PropTypes.func.isRequired,
    practice: PropTypes.any,
    getTreatments: PropTypes.func.isRequired,
    clearTreatmentTimeSlot: PropTypes.func.isRequired,
  };

  state = {};

  handleReload = () => {
    // eslint-disable-next-line no-restricted-globals
    if (location && location.reload) {
      // eslint-disable-next-line no-restricted-globals
      location.reload();
    }
  };

  componentDidMount() {
    this.props.clearTreatmentTimeSlot();
    this.props.getTreatments();
    this.props.selectPractice(this.props.practice);
  }

  render() {
    return (
      <Wrapper>
        <AppContainer
          onLogoClicked={this.handleReload}
          selectPractice={this.props.selectPractice}
          header={<FormattedMessage {...messages.header} />}
          dataCy="dashboard"
        >
          <Dashboard key="dashboard" />
        </AppContainer>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  width: 100%;
`;

const mapStateToProps = createStructuredSelector({
  clinicPage: makeSelectPracticePage(),
  practices: makeSelectPractices(),
  practice: makeSelectPractice(),
});

function mapDispatchToProps(dispatch) {
  return {
    getTreatments: () => dispatch(getTreatmentsAction()),
    getPractices: () => dispatch(getPracticesAction()),
    selectPractice: practice => dispatch(selectPracticeAction(practice)),
    clearTreatmentTimeSlot: () => dispatch(clearTreatmentFromTimeSlotAction()),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

const withReducer = injectReducer({ key: "DashboardPage", reducer });
const withSaga = injectSaga({ key: "DashboardPage", saga });

export default compose(
  withReducer,
  withSaga,
  withConnect,
)(DashboardPage);
